import { render } from "./GroupsListComponent.vue?vue&type=template&id=2e62b8bc"
import script from "./GroupsListComponent.vue?vue&type=script&lang=js"
export * from "./GroupsListComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__